import { setBeneficiary } from "../../../../redux/slices/beneficiarySlice"
import { store } from "../../../../redux/store"
import { setViewBeneficiaryModalOpen } from "../redux/slices/viewBeneficiaryModalSlice"

export const showViewBeneficiaryModal = (beneficiary) => {
  store.dispatch(setViewBeneficiaryModalOpen(true))
  store.dispatch(
    setBeneficiary({
      ...beneficiary,
      data: beneficiary.data || {}
    })
  )
}
